document.addEventListener('DOMContentLoaded', function () {
	AOS.init({
		offset: -400,
		once: true,
		duration: 800
	});
});
